import { useEffect, useState } from 'react';

/**
 * Retourne une version « retardée » de `value` : la valeur n'est propagée
 * qu'après `delayMs` sans nouveau changement. Utilisé pour câbler les barres de
 * recherche au param `?search=` de l'API sans déclencher une requête à chaque
 * frappe.
 */
export function useDebouncedValue<T>(value: T, delayMs = 350): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
